import { useContext } from 'react';
import { FormApiContext } from '../Context.js';

/* ----------------------- useFormApi ----------------------- */
function useFormApi() {
  var formApi = useContext(FormApiContext);
  return formApi;
}

export { useFormApi };
